/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface UtilExtractorPixels {
	width: number;
	height: number;
	array: Uint8Array;
}
